import React from 'react';

import {Grid} from "@mui/material";

import Journal from "components/Journal";
import CustomButton from "components/CustomButton";

import ScorePerContext from "./components/ScorePerContext";
import ProductInfos from "./components/ProductInfos";
import FieldSuggestion from "./components/FieldSuggestion";
import Actions from "./components/Actions";
import HeaderProductInfos from "./components/HeaderProductInfos";

import {getTranslation} from "domain/helpers/translations";
import calculateCompleteness from "domain/components/products/utils/CompletenessCalculator";

import {getFirstProductImage} from "utils/getFirstProductImage";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

function PimShow(props) {
    const handleBack = () => {
        props.history.push(MarketplaceRoutes.RETAILER_PRODUCTS_LIST(props.match.params.id))
    };

    // TODO temp
    const enrichmentProduct = props.location?.state?.enrichmentProduct;

    // TODO temp
    const journalEntries = [
        { title: "Import flux FLX-001",           date: "2024-02-15T14:32:00", type: "Système" },
        { title: "Auto-enrichissement IA lancé",  date: "2024-02-15T14:35:00", type: "IA" },
        { title: "Description générée",           date: "2024-02-15T14:36:00", type: "IA" },
        { title: "Couleur détectée",              date: "2024-02-15T14:36:00", type: "IA" },
    ];

    // TODO temp
    const scores = {
        seo: 42,
        marketplace: 55,
        driveToStore: 75
    }

    // TODO temp
    const productName = enrichmentProduct ? getTranslation(enrichmentProduct).name : 'Sneakers Runner Pro';
    const productSku = enrichmentProduct ? enrichmentProduct.sku : 'SKU-12345';
    const productBrand = enrichmentProduct ? enrichmentProduct.brand?.name : 'SportMax';
    const productPicture = enrichmentProduct ? getFirstProductImage(enrichmentProduct.pictures) : '';
    const productPrice = enrichmentProduct ? enrichmentProduct.highestPrice : 129.99;
    const productPrice30days = enrichmentProduct ? enrichmentProduct.lowestPrice : 99.99;
    const productStock = enrichmentProduct?.variations?.reduce((acc, variation) => acc + (variation.stock || 0), 0) || 78;
    const productStatus = enrichmentProduct ? (enrichmentProduct.status ? 1 : 0) : 1;
    const productCompleteness = enrichmentProduct ? calculateCompleteness(enrichmentProduct) : 45;

    return (
        <div style={{display: 'flex', flexDirection: 'column', marginLeft: '240px', padding: '24px'}}>
            <div style={{display:'flex', justifyContent: 'space-between'}}>
                <div style={{display: 'flex'}}>
                    <CustomButton
                        variant={'transparent'}
                        color={'default'}
                        noBorder
                        onClick={handleBack}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                             className="lucide lucide-arrow-left h-4 w-4">
                            <path d="m12 19-7-7 7-7"></path>
                            <path d="M19 12H5"></path>
                        </svg>
                    </CustomButton>
                    <HeaderProductInfos
                        name={productName}
                        tag={'IA'}
                        sku={productSku}
                        brand={productBrand}
                    />
                </div>

                <Actions/>
            </div>
            <Grid container xs={12} spacing={2} marginTop={3}>
                <Grid container item xs={4} spacing={2}>
                    <Grid item xs={12}>
                        <ProductInfos
                            picture={productPicture}
                            price={productPrice}
                            price30days={productPrice30days}
                            stock={productStock}
                            status={productStatus}
                            completeness={productCompleteness}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ScorePerContext scores={scores} />
                    </Grid>
                    <Grid item xs={12}>
                        <Journal title={'journal'} entries={journalEntries} />
                    </Grid>
                </Grid>
                <Grid container item xs={8}>
                    <FieldSuggestion />
                </Grid>
            </Grid>
        </div>
    );
}

export default PimShow;
